if (!customElements.get('size-guide')) {
  class SizeGuide extends HTMLElement {
    constructor() {
      super();

      this.modal = this.querySelector('[data-size-modal]');
      this.buttonsToggle = this.querySelectorAll('[data-button-toggle]');
      this.unitToggle = this.querySelector('[data-unit-toggle]');
      this.table = this.querySelector('.size-guide__content table');
      this.tableCells = [...this.table.querySelectorAll('td')].filter(cell => !cell.querySelector('strong'));
    }

    connectedCallback() {
      this.unitToggle.addEventListener('change', (e) => {
        const isCm = e.target.dataset.unit === 'cm';
        const convertValue = 2.54;

        this.tableCells.forEach(cell => {
          const isNumeric = this.isNumeric(cell.textContent);

          if (!isNumeric) return;

          const value = +cell.textContent;

          cell.textContent = isCm ? (value * convertValue).toFixed(1) : (value / convertValue).toFixed(1);
        });
      });

      this.buttonsToggle.forEach(button => {
        button.addEventListener('click', (e) => {
          if (e.target !== button) return;

          this.toggleOpen();
        });
      });

      document.body.appendChild(this.modal);
    }

    toggleOpen() {
      const isOpen = this.modal.classList.toggle('is-open');

      document.body.style.overflow = isOpen ? 'hidden' : '';
    }

    isNumeric(value) {
      return !isNaN(value) && !isNaN(parseFloat(value));
    }
  }

  customElements.define('size-guide', SizeGuide);
}
